import * as React from 'react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppDispatch } from '@user/store/hooks'
import { resetLeadOppProducts } from '@user/store/leadOppProducts'
import { CWQDialogContextProvider } from '@user/components/SoldServices'
import { NewAddOpportunityRouter } from '../AddOpportunityPage/NewAddOpportunityRouter'

export type OpportunitySources = 'new' | 'lead' | 'opportunity'

export function AddOpportunityPage() {
  const location = useLocation()
  const urlParams = new URLSearchParams(location?.search)

  const id = urlParams.get('id')
  const source = urlParams.get('source') || 'new'

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(resetLeadOppProducts())
  }, [dispatch])

  return (
    <CWQDialogContextProvider>
      <NewAddOpportunityRouter id={id} source={source} />
    </CWQDialogContextProvider>
  )
}
